<template>
  <div id="pageContent">
    <TopBanner v-if="routeName !== 'matchDetail'" :bg-img="bgImg"
               :main-title="mainTitle" :sub-title="subTitle" />
    <router-view class="contents"></router-view>
  </div>
</template>

<script>
import TopBanner from '@/components/Common/TopBanner.vue';

export default {
  name: 'MatchView',
  components: {
    TopBanner
  },
  data() {
    return {
      bgImg: 'black', // matchList
      mainTitle: '경기',
    }
  },
  computed: {
    subTitle() {
      return this.$route.meta.title;
    },
    routeName() {
      return this.$route.name;
    }
  }
}
</script>
